// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"2fba8df6","728":"ea617aa3"}[chunkId] + ".chunk.js";
};